var ProcessXaxisData = function (result, template) {

  var xAxisData = [];

  _.mapObject(result, function(val, key) {

      var valueArray = val;

      for (var k = 0; k < Object.keys(valueArray).length; k++) {
          xAxisData.push(valueArray[k].xAxisKey);
      }
  })

  // Remove duplicates from string and add to xAxis
  var xAxis;
  if (template == "true") {
      xAxis = {
          categories: _.uniq(xAxisData),
          labels: {
              enabled: false
          },
          visible: false,
          crosshair: true,
          shared: true
      };
  } else {
      xAxis = {
          categories: _.uniq(xAxisData),
          labels: {
              enabled: true
          }
      };
  }

  return xAxis;
}

exports.ProcessXaxisData=ProcessXaxisData;



//////////////////
// WEBPACK FOOTER
// ./src/modules/ProcessXaxisData/ProcessXaxisData.js
// module id = 15
// module chunks = 0